
import state from './mirasState.js'
import mutations from './mirasMutaions.js'
import actions from './mirasAction.js'
import getters from './mirasGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

